import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TextM } from 'frontend/js/modules/infra/dls/components/typography';
import ViewCampaignIcon from '../../../../icons/view-campaign.svg';
import { buildCampaignUrlFromList } from '../../../../../utils/url-builders';
import { useSession } from '../../../../../../../infra/session';
import { Link } from '../../../../../../../infra/routing';
import { t } from '../../../../../../../infra/i18n';
import styles from './styles.module.scss';
export var ViewAction = function (_a) {
    var campaign = _a.campaign, onBeforeAction = _a.onBeforeAction;
    var session = useSession().data;
    return (_jsxs(Link, { id: "view-campaign-".concat(campaign.id), to: buildCampaignUrlFromList({ campaign: campaign, session: session }), className: styles['action-button'], onClick: onBeforeAction, children: [_jsx(ViewCampaignIcon, {}), _jsx(TextM, { as: "span", children: t('engage:actions.view_campaign') })] }));
};
